import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {
    analisis: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************

const GET_ALL_ANALISIS = 'GET_ALL_ANALISIS'
const GET_ANALISIS_BY_NUMEROASOCIADO = 'GET_ANALISIS_BY_NUMEROASOCIADO'
const GET_ANALISIS_BY_LOTE = 'GET_ANALISIS_BY_LOTE'
const INSERT_ANALISIS = 'INSERT_ANALISIS'
const ACTUALIZAR_ANALISIS = 'ACTUALIZAR_ANALISIS'
const DELETE_ANALISIS = 'DELETE_ANALISIS'

//*******************************************************************************************************************


//METODOS
export const obtenerAnalisis = createAsyncThunk(
    GET_ALL_ANALISIS,
    async () => {
        try {
            const fullUrl = host + `AnalisisFQ/obtenerAnalisis`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerAnalisisByNumeroAsociado = createAsyncThunk(
    GET_ANALISIS_BY_NUMEROASOCIADO,
    async (numeroasociado) => {
        try {
            const fullUrl = host + `AnalisisFQ/obtenerAnalisisByNumeroAsociado/${numeroasociado}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerAnalisisByLote = createAsyncThunk(
    GET_ANALISIS_BY_LOTE,
    async (data) => {
        try {
            const fullUrl = host + `AnalisisFQ/obtenerAnalisisByLote`
            const res = await axios.post(fullUrl, data)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarAnalisis = createAsyncThunk(
    INSERT_ANALISIS,
    async (data) => {
        try {
            const fullUrl = host + `AnalisisFQ/agregarAnalisis`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarAnalisis = createAsyncThunk(
    ACTUALIZAR_ANALISIS,
    async (data) => {
        try {
            const fullUrl = host + `AnalisisFQ/actualizarAnalisis`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarAnalisis = createAsyncThunk(
    DELETE_ANALISIS,
    async (idanalisis) => {
        try {
            const fullUrl = host + `AnalisisFQ/eliminarAnalisis/${idanalisis}`
            //alert(JSON.stringify(data))
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosAnalisisFQSlice = createSlice({

    name: 'metodosAnalisisFQSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerAnalisis.fulfilled]: (state, { payload }) => {
            state.analisis = payload.data.data
        },
        [obtenerAnalisisByNumeroAsociado.fulfilled]: (state, { payload }) => {
        },
        [obtenerAnalisisByLote.fulfilled]: (state, { payload }) => {
        },
        [agregarAnalisis.fulfilled]: (state, { payload }) => {
        },
        [actualizarAnalisis.fulfilled]: (state, { payload }) => {
        },
        [eliminarAnalisis.fulfilled]: (state, { payload }) => {
        }
    },

})

export const { } = metodosAnalisisFQSlice.actions
export const AnalisisFQReducer = metodosAnalisisFQSlice.reducer